import { render, staticRenderFns } from "./MainServices.vue?vue&type=template&id=ed4f3d00&scoped=true"
import script from "./MainServices.vue?vue&type=script&lang=js"
export * from "./MainServices.vue?vue&type=script&lang=js"
import style0 from "./MainServices.vue?vue&type=style&index=0&id=ed4f3d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4f3d00",
  null
  
)

export default component.exports